import React from "react";

const FieldContainer = ({label, className, error, children, required}) =>
{
	return <div className={'Field_Container'+(className ? ' '+className : '')}>
		<div className="flex">
			{label ? <label>{label} {required ? <span className="text-danger">*</span> : null}</label> : null}
			{error ? <span className="validation-error"> ( {error.join(', ')} ) </span> : null} 
		</div>
		{children}
	</div>
}

export default FieldContainer;